import React from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  Slide,
  Snackbar,
  Stack,
  Typography,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

function TransitionLeft(props) {
  return <Slide {...props} direction="left" />;
}

function TransitionUp(props) {
  return <Slide {...props} direction="up" />;
}

function TransitionRight(props) {
  return <Slide {...props} direction="right" />;
}

function TransitionDown(props) {
  return <Slide {...props} direction="down" />;
}

const ControlSlideDirection = () => {
  const [open, setOpen] = React.useState(false);
  const [transition, setTransition] = React.useState(undefined);

  const handleClick = (Transition) => () => {
    setTransition(() => Transition);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Control Slide direction
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          You can change the direction of the Slide transition.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box>
          <PreviewAndEditor  language={"js"} value={""}>
            <Box sx={{ width: 300 }}>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Button variant="text" onClick={handleClick(TransitionUp)}>
                  Up
                </Button>
              </Box>
              <Grid container justifyContent="center">
                <Grid item xs={6}>
                  <Button variant="text" onClick={handleClick(TransitionRight)}>
                    Left
                  </Button>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Button variant="text" onClick={handleClick(TransitionLeft)}>
                    Right
                  </Button>
                </Grid>
              </Grid>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Button variant="text" onClick={handleClick(TransitionDown)}>
                  Down
                </Button>
              </Box>
              <Snackbar
                open={open}
                onClose={handleClose}
                TransitionComponent={transition}
                message="I love snacks"
                key={transition ? transition.name : ""}
              />
            </Box>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default ControlSlideDirection;
